import { Grid, MenuItem, Select } from "@mui/material";
import * as React from "react";
import { CheckboxDropdown } from "ui/Scripts/source/components/framework/Dropdown/CheckboxDropdown";
import { Base } from "ui/Scripts/source/framework/base";
import { IIdTitle } from "ui/Scripts/source/models/common/idTitle";
import { Translations } from "ui/Scripts/source/models/translations";
import { AppUtils } from "../../../../framework/appUtils";
import { SaveDataObj } from "../../../../framework/saveData";
import { IListFilterItem } from "../../../../models/common/listFilterItem";
import { DrawerContent } from "../../../framework/Drawer/DrawerContent";
import { FilterButtons } from "../../../framework/Filters/FilterButtons";
import { FilterSearchField } from "../../../framework/Filters/FilterSearchField";
import { FormField } from "../../../../../../../QTeamSystems.QTeamIntra.Ui/Scripts/source/components/framework/FormField";
import { GridRow } from "../../../framework/Grid/GridRow";
import { PageFilterConditionDrawer } from "../../../framework/Page/PageFilterConditionDrawer";

export interface ICompanyPageListFilterDrawerProp {
    open: boolean;
    classes?: string;
    filter: IListFilterItem;
    activityFilters: IIdTitle[];
    companyGroups: IIdTitle[];
    selectedActivityFilterId: string;
    selectedCompanyGroupIds: string[];
    canRemoveSharedFilters: boolean;
    onSaveFilter: (saveAs: boolean, onGetGeneralFilter: () => any) => void;
    onRemoveFilter: (filterId: string) => void;
    onOk: (closeDialog: boolean, selectedActivityFilterId: string, selectedCompanyGroupIds: string[]) => any;
    onCancel: () => void;
}

export interface ICompanyPageListFilterDrawerState {
    selectedCompanyGroupIds: string[];
    selectedActivityFilterId: string;
}

export class CompanyPageListFilterDrawer extends React.Component<ICompanyPageListFilterDrawerProp, ICompanyPageListFilterDrawerState> {
    private orgStateHash: string = "";

    getStateFromProps = (props: ICompanyPageListFilterDrawerProp): ICompanyPageListFilterDrawerState => {
        return {
            selectedActivityFilterId: props.selectedActivityFilterId,
            selectedCompanyGroupIds: props.selectedCompanyGroupIds.slice(0)
        };
    };

    constructor(props: ICompanyPageListFilterDrawerProp) {
        super(props);
        this.state = this.getStateFromProps(props);
        this.orgStateHash = this.getSaveDataFromState(props, this.state).hash;
    }

    componentDidUpdate(prevProps: ICompanyPageListFilterDrawerProp, prevState: ICompanyPageListFilterDrawerState): void {
        const props = this.props;
        if (!prevProps || prevProps?.filter?.getHash() === props?.filter?.getHash()) return;
        const state = this.getStateFromProps(props);
        this.setState(state);
        this.orgStateHash = this.getSaveDataFromState(props, state).hash;
    }

    handleChange = (event) => {
        const target = event.target;
        const value: string = target.value;
        const name: string = target.name;
        if (name === "activityFilterId") {
            this.setState({ selectedActivityFilterId: value });
        }
    };

    handleChangeCompanyGroupIds = (selectedCompanyGroupIds: string[]) => {
        this.setState({
            selectedCompanyGroupIds
        });
    };

    getSaveDataFromState = (props: ICompanyPageListFilterDrawerProp, state: ICompanyPageListFilterDrawerState): SaveDataObj => {
        const result = new SaveDataObj();
        result.append("selectedActivityFilterId", state.selectedActivityFilterId ? state.selectedActivityFilterId : null);
        result.append("selectedCompanyGroupIds", JSON.stringify(state.selectedCompanyGroupIds));
        return result;
    };
    
    static filterIsSet = (activityFilters: IIdTitle[], companyGroups: IIdTitle[],
        selectedActivityFilterId: string, selectedCompanyGroupIds: string[]): boolean => {
        return !(selectedActivityFilterId === activityFilters[1].id && Base.equalStrArrays(selectedCompanyGroupIds, [companyGroups[0].id]));
    };

    handleSaveFilter = async (saveAs: boolean) => {
        const props = this.props;
        const state = this.state;
        if (!saveAs) {
            props.onOk(false, state.selectedActivityFilterId, state.selectedCompanyGroupIds);
            await this.props.onSaveFilter(false, null);
        } else {
            await this.props.onSaveFilter(true, () => {
                return props.onOk(false, state.selectedActivityFilterId, state.selectedCompanyGroupIds);
            });
        }
    };

    handleClear = () => {
        const props = this.props;
        this.setState({
            selectedActivityFilterId: props.activityFilters[1].id,
            selectedCompanyGroupIds: [props.companyGroups[0].id]
        });
    };

    handleSave = async () => {
        const props = this.props;
        const state = this.state;
        props.onOk(true, state.selectedActivityFilterId, state.selectedCompanyGroupIds);
    };

    handleCancel = async (checkChanges: boolean) => {
        AppUtils.cancelEditDialog(checkChanges, this.getSaveDataFromState(this.props, this.state).hash, this.orgStateHash, this.handleSave, this.props.onCancel, Translations.YouHaveUnapprovedChangesDoYouWantApproveChanges);
    };

    render() {
        const props = this.props;
        const state = this.state;
        return (
            <PageFilterConditionDrawer
                open={props.open}
                onClose={() => this.handleCancel(false)}
            >
                <DrawerContent
                    content={
                        <>
                            <FilterSearchField
                                filter={props.filter}
                                canRemoveSharedFilters={props.canRemoveSharedFilters}
                                onSaveFilter={this.handleSaveFilter}
                                onRemoveFilter={props.onRemoveFilter}
                            />
                            <GridRow>
                                <Grid item sm={12}>
                                    <FormField title={Translations.Company}>
                                        <Select name="activityFilterId" title={Translations.Company} value={state.selectedActivityFilterId} onChange={this.handleChange}>
                                            {props.activityFilters.map(activityFilter =>
                                                <MenuItem key={activityFilter.id} value={activityFilter.id}>{activityFilter.title}</MenuItem>
                                            )}
                                        </Select>
                                    </FormField>
                                </Grid>
                            </GridRow>
                            <GridRow>
                                <Grid item sm={12}>
                                    <FormField title={Translations.CompanyGroup}>
                                        <CheckboxDropdown
                                            required={true}
                                            selectedIds={state.selectedCompanyGroupIds}
                                            toggleAll={true}
                                            toggleAllId={Base.emptyGuid}
                                            values={props.companyGroups}
                                            onChange={this.handleChangeCompanyGroupIds}
                                        />
                                    </FormField>
                                </Grid>
                            </GridRow>
                        </>
                    }
                    actions={
                        <FilterButtons
                            onSave={this.handleSave}
                            onCancel={() => this.handleCancel(false)}
                            onClear={this.handleClear}
                        />
                    }
                />
            </PageFilterConditionDrawer>
        );
    }
}